import React from 'react'
import { Icon } from '@frontend/pole-ui/lib/components/Icon'
import { GlassMorphIcon, InjectHtml } from '@/components/ui'
import { LandingBlockContainer } from '..'
import type { IAboutProps } from './interfaces'
import './styles.scss'

const LandingAbout: React.FC<IAboutProps> = props => {
  const { about, titleId, title, blockId } = props

  return (
    <div className="landing-constructor-about">
      <LandingBlockContainer titleId={titleId} title={title} titleClassName="space-holder64-from-sm space-holder32-sm" blockId={blockId}>
        <div className="landing-constructor-about-texts space-holder88 space-holder56-sm">
          {about?.map(({ icon, iconGlas, textId, text }, key) => (
            <div key={key} className="landing-constructor-about-text">
              <div className="landing-constructor-about-text__img-circle">
                {!!icon && <Icon component={icon} className="landing-constructor-about-texts__icon" />}
                {!!iconGlas && <GlassMorphIcon image={iconGlas} />}
              </div>
              <InjectHtml TagName="p" className="color_pale-black landing-constructor-about-text__text" textId={textId} html={text} />
            </div>
          ))}
        </div>
      </LandingBlockContainer>
    </div>
  )
}

export default LandingAbout
